import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import TabStripProps from './TabStripProps'

import Animation from '../Common/Animation'
import Scrollable from '../Common/Scrollable'

export default {
    props: TabStripProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Scrollable
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoTabStrip(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTabStrip()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoTabStrip/KendoTabStripMixin.js